// @flow

import styled from "styled-components";

const Blur = styled.div`
  bottom: 0;
  background: rgb(0, 0, 0);
  display: none;
  left: 0;
  opacity: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1;
`;

export default Blur;



// WEBPACK FOOTER //
// ./src/common/blur.js